'use strict';

var seed = 0;
module.exports = function guid() {
  return Date.now() + '_' + seed++;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-util/lib/guid.js
 ** module id = 439
 ** module chunks = 0
 **/